const DOCUMENT_UPLOAD_SOURCE_TAG_SCOPE = 'document-upload-source-tag';

export const DocumentUploadSourceTagTestIds = {
  getTagId: documentId => `${DOCUMENT_UPLOAD_SOURCE_TAG_SCOPE}.tag-${documentId}`,
};
